module.exports = __webpack_public_path__ + "assets/img/28423.webp?c4b3824115f97839708770bdb03cfb63";